function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 45,
    viewBox: "0 0 55 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.08294 19.3722C18.659 13.0217 28.3786 8.835 33.2418 6.81222C47.1274 1.03674 50.0126 0.0334815 51.8932 0.000353222C52.3069 -0.00693298 53.2317 0.095574 53.8307 0.58167C54.3366 0.992121 54.4758 1.54658 54.5424 1.93573C54.609 2.32488 54.6919 3.21138 54.626 3.90407C53.8735 11.8103 50.6176 30.9965 48.9612 39.8515C48.2603 43.5984 46.8802 44.8548 45.5442 44.9777C42.6406 45.2449 40.4357 43.0588 37.6234 41.2153C33.2228 38.3306 30.7367 36.5349 26.4651 33.72C21.5285 30.4669 24.7287 28.6789 27.542 25.7569C28.2783 24.9921 41.0716 13.3556 41.3192 12.3C41.3502 12.168 41.3789 11.6759 41.0866 11.416C40.7942 11.1562 40.3627 11.245 40.0513 11.3157C39.61 11.4159 32.5799 16.0625 18.9611 25.2556C16.9656 26.6259 15.1582 27.2935 13.5388 27.2585C11.7535 27.2199 8.31937 26.2491 5.76646 25.4192C2.6352 24.4014 0.146546 23.8633 0.363252 22.1346C0.476126 21.2343 1.71602 20.3135 4.08294 19.3722Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram1);
export default __webpack_public_path__ + "static/media/telegram1.2310eafbe061592298cefaa6864180e4.svg";
export { ForwardRef as ReactComponent };